import React, { useState } from "react";
import { Upload, message, Avatar } from "antd";
import { CameraOutlined, UserOutlined, LoadingOutlined } from "@ant-design/icons";
import { uploadAvatar } from "app/services/user.service";
import { getFullUrl } from "constants/func";
import { colors } from "../../theme/theme";

const AvatarUpload = ({ value, onChange }) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (file) => {
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("image", file);

      const res = await uploadAvatar(formData);
      if (res) {
        onChange?.(res);
        message.success("Tải ảnh thành công!");
      } else {
        message.error("Tải ảnh thất bại!");
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Có lỗi xảy ra khi tải ảnh!");
    } finally {
      setUploading(false);
    }
  };

  const uploadProps = {
    name: "avatar",
    showUploadList: false,
    accept: "image/png,image/jpeg,image/webp,image/gif",
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("Chỉ chấp nhận file ảnh!");
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("Ảnh phải nhỏ hơn 5MB!");
        return false;
      }
      handleUpload(file);
      return false; // Prevent auto upload
    },
  };

  return (
    <Upload {...uploadProps}>
      <div
        style={{
          cursor: "pointer",
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 8,
        }}
      >
        <div style={{ position: "relative" }}>
          <Avatar
            size={80}
            src={getFullUrl(value)}
            icon={<UserOutlined />}
            style={{
              border: `2px solid ${colors.primary[300]}`,
              backgroundColor: colors.primary[50],
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: colors.primary[500],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 14,
              border: "2px solid #fff",
              boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
            }}
          >
            {uploading ? <LoadingOutlined /> : <CameraOutlined />}
          </div>
        </div>
        <span style={{ fontSize: 12, color: colors.neutral[500] }}>
          {uploading ? "Đang tải..." : "Bấm để chọn ảnh"}
        </span>
      </div>
    </Upload>
  );
};

export default AvatarUpload;
